module.exports = "data:image/svg+xml;base64,PHN2ZyBkYXRhLXYtNDFiZTY2MzM9IiIgdmlld0JveD0iMCAwIDE2IDE2IiB3aWR0aD0iMWVtIiBoZWlnaHQ9IjFlbSIgZm9jdXNhYmxlPSJmYWxzZSIgcm9sZT0iaW1nIiBhcmlhLWxhYmVsPSJjaGVjayIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsPSJjdXJyZW50Q29sb3IiIGNsYXNzPSJiaS1jaGVjayBteC1hdXRvIGItaWNvbiBiaSI+PGcgZGF0YS12LTQxYmU2NjMzPSIiPjxwYXRoIGQ9Ik0xMC45NyA0Ljk3YS43NS43NSAwIDAgMSAxLjA3IDEuMDVsLTMuOTkgNC45OWEuNzUuNzUgMCAwIDEtMS4wOC4wMkw0LjMyNCA4LjM4NGEuNzUuNzUgMCAxIDEgMS4wNi0xLjA2bDIuMDk0IDIuMDkzIDMuNDczLTQuNDI1YS4yNjcuMjY3IDAgMCAxIC4wMi0uMDIyeiI+PC9wYXRoPjwvZz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/check.svg
// module id = c8vr
// module chunks = 1